export default __webpack_public_path__ + "static/media/OrderStatus_1.1fc1a45f.svg";